import { Badge, Divider, Flex, Grid, Group, Text } from "@mantine/core";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { NumberField, Show, TextField } from "@refinedev/mantine";
import { DetailsCard } from "components/common/show/DetailsPair";
import { History } from "components/common/show/History";
import { Plan } from "entities/plan";

export const PlanShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<Plan>();
  const { data, isLoading } = queryResult;

  const plan = data?.data;
  if (!plan) return <div />;

  return (
    <Show isLoading={isLoading}>
      <Grid>
        <Grid.Col span={8}>
          <Flex gap="sm" direction="column">
            <DetailsCard title="Description">
              <TextField value={plan.description} />
            </DetailsCard>
            <History<Plan> resources={"plans"} entityId={plan.id} />
          </Flex>
        </Grid.Col>
        <Grid.Col span={4}>
          <Flex direction="column" gap="sm">
            <DetailsCard title="Basic Information">
              <NumberField value={plan.id} />
            </DetailsCard>
            <DetailsCard title="Name">
              <Text>{plan.name}</Text>
            </DetailsCard>
            <DetailsCard title="Price">
              <Text>${(plan.price / 100).toFixed(2)}</Text>
            </DetailsCard>
            <DetailsCard title="Period">
              <Badge size="lg" color="blue">
                {plan.period} Months
              </Badge>
            </DetailsCard>
            <DetailsCard title="Last Synced At">
              <Text>{new Date(plan.last_synced_at).toJSON()}</Text>
            </DetailsCard>
          </Flex>
        </Grid.Col>
      </Grid>
    </Show>
  );
};
